module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container forbidden"
  }, [_vm._m(0), _c('a', {
    staticClass: "themed text",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("返回")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "ui center aligned icon header"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _c('div', {
    staticClass: "content"
  }, [_vm._v("无访问权限")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30362b4e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Forbidden.vue
// module id = 423
// module chunks = 0